import { scrollToEl, addHashToURL, headerOffsetHeight } from './helpers';

const skipToContent = document.querySelector('.skip-to-content');

skipToContent.onkeydown = (e) => {
	if (e.code !== 'Tab') {
		e.preventDefault();
		const siteContent = document.querySelector('.site-content a, .site-content [tabindex]');
		siteContent.focus();
	}
};

/**
 * Scroll to hash on click, and update URL.
 *
 * @since  1.0.0
 */
document.addEventListener('click', (e) => {
	if (e.target.hash && e.target.hash !== '#popup-form') {
		e.preventDefault();
		const { target } = e;
		const { hash, pathname, hostname } = target;
		const el = document.querySelector(hash) || document.querySelector(`[name=${hash.slice(1)}]`);

		// If we don't have a target element then bail.
		if (!el) return;

		const { pathname: windowPathname, hostname: windowHostname } = window.location;
		const regex = /^\//;

		if (windowPathname.replace(regex, '') === pathname.replace(regex, '') && windowHostname === hostname) {
			scrollToEl(el, headerOffsetHeight(el));
			addHashToURL(hash);
		}
	}
});
